import CreatorRevenueDetailedComponent from "./CreatorRevenueDetailedComponent";

export default CreatorRevenueDetailedComponent;
